import { render, staticRenderFns } from "./TableCostos.vue?vue&type=template&id=3342bcca&"
import script from "./TableCostos.vue?vue&type=script&lang=js&"
export * from "./TableCostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports